// Catégories Qonto internes qui ne sont jamais assujetties à la TVA :
// virements internes, frais bancaires, prélèvements automatiques
// (mouvements de trésorerie inter-comptes ou frais hors champ TVA).
export const INTERNAL_QONTO_TYPES = new Set([
  'transfer',
  'internal_transfer',
  'qonto_fee',
  'bank_fee',
  'direct_debit',
]);

/**
 * Une transaction est éligible à l'édition d'un taux de TVA dès lors que ce
 * n'est pas une opération interne. Vrai pour débits (TVA déductible) et
 * pour crédits (TVA collectée).
 */
export function isVatApplicable(tx) {
  if (!tx) return false;
  return !INTERNAL_QONTO_TYPES.has(tx.operation_type);
}
